<template>
  <div
    class="trainer-layout tralay no-scroll-track"
    tour="trainer"
    :class="[
      { tralay_mobile: mobile },
      {
        'tralay_focus-mode': !mobile && (forceFocusMode || focusMode || multipleTables),
      },
      { tralay_singletable: !multipleTables },
      { tralay_multitable: multipleTables },
      { tralay_active: active },
      { tralay_locked: tableLocked },
      { 'tralay_no-mobile-confirm-btns': mobile && !hasConfirmBtns },
      `tralay_tables_${numOfTables}`,
    ]"
  >
    <div class="tralay_center text-noselect">
      <MessageOverlaySkeleton
        v-if="tra.trainer_error"
        class="tralay_message-overlay_back mso_blurred"
      />
      <TrainerStreetBtns
        v-if="!mobile && hasTopStreetBtns"
        :namespace="namespace"
        :historyHand="l_historyHand"
        :spot="history_spot"
        class="tralay_top-street-btns trastrbtns_as-nav"
      />
      <PokerHistoryEvents
        tour="tra_live_hspots"
        :namespace="namespace"
        :canAISolve="false"
        :minimized="true"
        :clickableBoard="false"
        :hasTmpBoard="true"
        :hasWatcherEnabled="false"
        :hasTurnPreload="false"
        :noNextActionsWithoutBoard="false"
        :hasInitialLoad="false"
        :hasShortcuts="false"
        :skeletonTiles="skeletonTiles"
        :hasCorrectness="pref.fh_trainer_quick_result"
        :actionEmitOnly="true"
        :clickableGG="true"
        :bettingInfo
        :customLoadingEvents="true"
        :loadingSkeleton="loadingSession || loadingSetup"
        class="tralay_hs"
        style="--padding: var(--hs-padding)"
        @click="handleHsClick"
      />
      <div class="tralay_center_content">
        <MessageOverlaySkeleton
          v-if="tra.trainer_error"
          class="tralay_message-overlay"
          :isBlurred="false"
          :isTopDown="true"
          style="--content-margin: 5rem auto auto auto; --back-from: transparent"
        >
          <MessagesTrainerError
            :namespace="namespace"
            :item="tra.trainer_error"
            :tstPrefix="`${tstPrefix}_error`"
          />
          <TrainerConfirmBtns
            class="mt-4 f-wrap"
            v-bind="confirmBtnsProps"
            :active="active"
            v-on="confirmBtnsEvents"
          />
        </MessageOverlaySkeleton>

        <div class="tralay_table">
          <PokerTableTrainer
            :tableFinished="tableLocked"
            :hasStudySpotBtn="hasStudySpotBtn && replayOnly"
            :hasTableControls="multipleTables"
            :hasHintsMenu="multipleTables"
            :tableDirection="multipleTables ? 'horizontal' : ''"
            :hasStreak="tableHasStreak"
            :namespace
            :useNextPot
            :useNextBoard
            :useNextPlayer
            :hasSounds
            :streak
            :sessionCount
            :hasSessionCount
            :opponentHandOnlyOnShowdown
            :gameformat
            :customTree
            :queryGameformat
            :querySetup
            :queryHandTmp
            :queryStandoff
            :queryHandOpTmp
            :betInPot
            :heroPosition
            :hasStandoff="true"
            :hasDepthText
            :rng
            :rngMode="pref.fh_rng"
            :hasRng="pref.fh_trainer_rng_visible"
            :action="quickResult"
            :hasQuickResult="true"
            :showQuickResult="tra.trainer_quick_result_visible"
            :spot="history_spot"
            :tstPrefix="tstPrefix"
            :style="`
            --table-ver-max-width: var(--tbl-ver-max-width);
            --table-hor-min-height: var(--tbl-hor-min-height);
            --table-hor-max-width: var(--tbl-hor-max-width);
            --clr-table-back: var(--clr-trainer-table-back);
            --clr-table-outline: var(--clr-trainer-table-outline);
            --standoff-top: var(--tbl-standoff-top);
            ${
              !gmfNotICM
                ? `
                --clr-player_folded:var(--clr-black-14);
                --clr-player-name_folded:var(--clr-black-6)`
                : ''
            }
            `"
            @swipe:left="go(1)"
            @swipe:right="go(-1)"
            @timebank:stop="stopTimebank"
          >
          </PokerTableTrainer>
          <ExpandableContainer
            class="tralay_table_actions"
            style="--exp-width: var(--aa-width)"
            v-bind="swipePanelProps"
            :mustBeScrolledUpDown="true"
            @close="handleExpContClose"
          >
            <template #default="{ swp_events, methods, open }">
              <div
                class="tralay_table_actions_content"
                :class="{
                  tralay_table_actions_content_expanded: open,
                }"
                v-on="swp_events"
              >
                <div
                  v-if="mobile"
                  v-show="!swipePanelProps.ignoreSwipeVertical"
                  class="tralay_mhandle"
                  @click="methods.toggle()"
                >
                  <i
                    class="mdi mdi-chevron-up tralay_mhandle_icon transition_03"
                    :class="{ rotated_180_before: open }"
                  ></i>
                </div>

                <TrainerStreetBtns
                  v-if="hasMobileStreetBtns && !loading && (tra.trainer_result_visible || open)"
                  :namespace
                  :historyHand="l_historyHand"
                  :spot="history_spot"
                  :loading="loadingShowdown"
                  :hasSounds
                  :hasGG="true"
                  class="tralay_mobile-street-btns trastrbtns_as-nav"
                />
                <TrainerActions
                  v-if="actionsProps.hasActions"
                  tour="tra_live_actions"
                  :gridClass="
                    (mobile && !loading ? tra.trainer_result_visible || open : false)
                      ? `tract_grid_mobile`
                      : ''
                  "
                  v-bind="actionsProps"
                  class="tralay_actions anim-fade-in"
                  :currentPot
                  :bettingInfo
                  :active="active && !tra.trainer_error"
                  :tstPrefix
                  @click:action="handleActionClick"
                />
                <TrainerComplexActions
                  v-if="actionsProps.hasComplexActions"
                  v-bind="actionsProps"
                  ref="complexActions"
                  :gridClass="
                    (mobile ? tra.trainer_result_visible || open : false) ? `tract_grid_mobile` : ''
                  "
                  :bettingInfo
                  :allActionsVisible="open"
                  :active="active && !tra.trainer_error"
                  class="tralay_complex-actions anim-fade-in"
                  @click:action="handleActionClick"
                />
                <TrainerSliderActions
                  v-if="actionsProps.hasSlider"
                  v-bind="actionsProps"
                  class="tralay_slider anim-fade-in"
                  @update="handleSliderUpdate"
                />
                <TrainerFrequencyCharts
                  v-if="actionsProps.hasChart"
                  :legendRaiseFirst="true"
                  :hasEv="!bot_spot"
                  class="tralay_freq-charts"
                  freKey="frequency"
                  v-bind="chartProps"
                />
                <TrainerFinishMessage
                  v-if="actionsProps.hasFinishMessage"
                  :namespace="namespace"
                  :loading="loadingShowdown"
                  class="tralay_finish-message"
                  data-tst="trainer_finish_message"
                  :hasEvLoss="false"
                  :hasStreets="true"
                  :historyHand="l_historyHand"
                  :hasSounds="hasSounds"
                >
                  <div
                    v-if="confirmBtnsProps.hasSolutionEndMessage"
                    class="tralay_finish-warning-message"
                  >
                    <i class="mdi mdi-information-outline mr-1"></i>
                    {{ $t(`messages.solution_no_postfop`) }}
                  </div>
                </TrainerFinishMessage>
                <div
                  v-else-if="confirmBtnsProps.hasSolutionEndMessage"
                  class="anim-fade-in tralay_finish-warning-message tralay_finish-warning-message_standalone"
                >
                  <i class="mdi mdi-information-outline mr-1"></i>
                  {{ $t(`messages.solution_no_postfop`) }}
                </div>
                <TrainerResultChartSwitcherMenu
                  v-if="hasResultSwitcher && !showdown_spot"
                  class="tralay_result-switcher"
                  :iconOpener="'mdi-dots-horizontal'"
                />
                <TrainerConfirmBtns
                  v-if="!tra.trainer_error"
                  v-bind="confirmBtnsProps"
                  :active="active && !tra.trainer_error"
                  class="tralay_confirm-btns"
                  v-on="confirmBtnsEvents"
                >
                  <template #progress-line>
                    <ProgressLine
                      :seconds="3"
                      class="tralay_progress-line prgsline"
                      style="
                        --clr-line: var(--clr-white-0);
                        --clr-back: rgba(0, 0, 0, 0.5);
                        --height: 2px;
                      "
                    />
                  </template>
                </TrainerConfirmBtns>
              </div>
            </template>
          </ExpandableContainer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import PokerTableTrainer from '@/components/PokerTable/PokerTableTrainer'
import TrainerActions from '@/components/Trainer/TrainerActions'
import TrainerComplexActions from '@/components/Trainer/TrainerComplexActions'
import MessagesTrainerError from '@/components/Poker/Overlays/Messages/MessagesTrainerError'
import TrainerConfirmBtns from '@/components/Trainer/TrainerConfirmBtns'
import TrainerSliderActions from '@/components/Trainer/TrainerSliderActions'
import TrainerFinishMessage from '@/components/Trainer/TrainerFinishMessage'
import ProgressLine from '@/components/lib/ProgressLine'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import ExpandableContainer from '@/components/ExpandableContainer/ExpandableContainer'
import TrainerFrequencyCharts from '@/components/Trainer/TrainerFrequencyCharts'
import TrainerStreetBtns from '@/components/Trainer/TrainerStreetBtns'
import TrainerResultChartSwitcherMenu from '@/components/Trainer/TrainerResultChartSwitcherMenu'
// import TrainerQuizz from '@/components/Trainer/TrainerQuizz'
import screen_mix from '@/mixins/screen_mix'
import trainer_broadcast_mix from '@/mixins/trainer_broadcast_mix'

import findLast from 'lodash/findLast'

// `
export default {
  name: 'Trainer',
  components: {
    PokerHistoryEvents,
    PokerTableTrainer,
    TrainerActions,
    TrainerComplexActions,
    TrainerConfirmBtns,
    MessagesTrainerError,
    TrainerFinishMessage,
    TrainerSliderActions,
    ProgressLine,
    MessageOverlaySkeleton,
    ExpandableContainer,
    TrainerFrequencyCharts,
    TrainerStreetBtns,
    TrainerResultChartSwitcherMenu,
    // TrainerQuizz,
  },
  mixins: [screen_mix, trainer_broadcast_mix],
  props: {
    namespace: { String, required: true },
    hasRightPanel: { type: Boolean, default: true },
    hasMultipleTables: { type: Boolean, default: true },
    hasSession: { type: Boolean, default: true },
    hasStreak: { type: Boolean, default: true },
    hasSilentFetch: { type: Boolean, default: true },
    hasConfirmBtns: { type: Boolean, default: true },
    hasResultSwitcher: Boolean,
    confirmBtnsHasMenu: { type: Boolean, default: true },
    hasStudySpotBtn: { type: Boolean, default: true },
    opponentHandOnlyOnShowdown: Boolean,
    active: Boolean,
    replayOnly: Boolean,
    sessionInProgress: Boolean,
    restoreHandOnly: Boolean,
    forceFocusMode: Boolean,
    hasSounds: Boolean,
    historyHand: Object,
    hasTopStreetBtns: Boolean,
    repeatHandBtnAsPrimary: Boolean,
    // handsConfigure: Boolean,
    grouping: { default: () => 'swv_grouping_none' },
    tstPrefix: { default: 'trainer_table_0' },
  },
  data() {
    return {
      hasSessionFinishMessage: true,
    }
  },
  methods: {
    start({ settingsHand = null, callSetup = true, mockSetup = false, resetTmp = true } = {}) {
      this.$store.dispatch(`${this.namespace}/trainer_hand_initialize`, {
        settingsHand,
        callSetup,
        resetTmp,
        mockSetup,
      })
    },
    stopHands() {
      // this.$store.dispatch(`hands_stop`)
      const sessions = this.$store.getters.history_sessions
      const lastSession = sessions[sessions.length - 1] || null
      const sessionId = this.$store.getters.session_uid
      const sessionFinished = this.$store.getters.session_finished
      if (!sessionFinished && lastSession?.uid === sessionId) {
        this.$store.dispatch(`stats_show_session_result`, lastSession)
      } else {
        this.$store.dispatch(`hands_stop`)
      }
    },
    stopNewHand() {
      this.$store.dispatch(`${this.namespace}/trainer_auto_new_hand_stop`)
    },
    newHand() {
      const action = 'newhand'
      if (this.replayOnly && this.sessionInProgress) {
        this.openRestoreHandDialog(action)
        return
      }
      if (this.restoreHandOnly) {
        this.$store.dispatch(`${this.namespace}/trainer_restore_hand`, { action })
        return
      }
      this.$store.dispatch(`${this.namespace}/trainer_new_hand`)
    },
    repeatHand() {
      const action = 'repeathand'
      if (this.replayOnly && this.sessionInProgress) {
        this.openRestoreHandDialog(action)
        return
      }
      if (this.restoreHandOnly) {
        this.$store.dispatch(`${this.namespace}/trainer_restore_hand`, { action })
        return
      }
      this.$store.dispatch(`${this.namespace}/trainer_repeat_hand`)
    },
    switchToCustomSpotHand() {
      if (this.replayOnly && this.sessionInProgress) {
        this.openRestoreHandDialog('switchtocustomspot')
        return
      }
      if (this.restoreHandOnly) {
        this.$store.dispatch(`${this.namespace}/trainer_restore_hand`, {
          action: 'switchtocustomspot',
        })
        return
      }
      this.$store.dispatch(`${this.namespace}/trainer_switch_to_custom_spot`)
    },
    returnToGame() {
      if (this.replayOnly && this.sessionInProgress) {
        this.openRestoreHandDialog('returntogame')
        return
      }
      if (this.restoreHandOnly) {
        this.$store.dispatch(`${this.namespace}/trainer_restore_hand`, { action: 'returntogame' })
        return
      }
      this.$store.dispatch(`${this.namespace}/trainer_hand_return_to_game`)
    },
    openRestoreHandDialog(confirm_action) {
      const dialog = `trainer-restore-hand-dialog_action-${confirm_action}`
      this.$store.dispatch('router_set_dialogs', dialog)
      return false
    },
    handleSliderUpdate({ actions }) {
      this.$store.commit(`${this.namespace}/trainer_set`, {
        key: 'trainer_slider_actions',
        value: actions,
      })
    },
    handleConfirmSlider() {
      const actions = this.sliderActions || this.hs_slider_actions
      const action = actions.find(e => e.is_preselected) || actions[0]
      this.handleActionClick(action)
    },
    handleActionClick(action) {
      this.$store.dispatch(`${this.namespace}/trainer_handle_action_selection`, {
        namespace: this.namespace,
        action,
      })
    },
    confirmActionSelection(action) {
      this.$store.dispatch(`${this.namespace}/trainer_confirm_action_selection`, {
        namespace: this.namespace,
        action,
      })
    },
    handleExpContClose() {
      if (!this.tra.trainer_hand_finished && !this.bot_spot) {
        this.changeMove()
      }
    },
    changeBotAction() {
      this.tra.trainer_hand_finished = false
      this.tra.trainer_quick_result_visible = false
      this.tra.trainer_result_visible = false
      this.$store.dispatch(`${this.namespace}/trainer_clear_timebank`)
      this.$store.dispatch(`${this.namespace}/trainer_auto_new_hand_stop`)
    },
    hideResults() {
      this.tra.trainer_result_visible = false
    },
    changeMove() {
      this.hideResults()
      this.tra.trainer_changed_move = true
    },
    handleHsClick() {
      if (this.tra.trainer_error) return
      this.resetTimeoutsAndNext()
    },
    go(num) {
      if (this.tra.trainer_error) return
      if (!this.history_spot) return

      this.resetTimeoutsAndNext()

      const spot_id = this.history_spot.id + num
      this.$store.dispatch(`poker_trainer_hide_loading`, { namespace: this.namespace })
      this.$store.dispatch('poker_replay_spot', {
        namespace: this.namespace,
        spot_id,
        hasSounds: this.hasSounds,
      })
    },
    resetTimeoutsAndNext() {
      if (this.instaNewHand) {
        this.tra.trainer_instahand_gg_visible = true
      }
      this.$store.dispatch(`${this.namespace}/trainer_auto_new_hand_stop`)
      this.$store.dispatch(`${this.namespace}/trainer_clear_timebank`)
      this.$store.dispatch(`${this.namespace}/gamestate_reset_next`)
    },
    setOverviewSpot() {
      if (!this.apiPractice) return
      if (!this.history_spot_trainer) return
      if (
        this.history_spot_trainer?.id === this.overviewSpot?.id &&
        this.history_spot_trainer?.uid === this.overviewSpot?.uid
      )
        return
      this.tra.trainer_overview_spot = this.history_spot_trainer
    },
    getHeroCorrectness() {
      if (!this.hasSilentFetch) return
      if (this.showdown_spot) return

      const actionsHaveCorrectness = this.available_actions.some(i => 'correctness' in i)
      if (
        !actionsHaveCorrectness &&
        !this.loadingSession &&
        !this.loadingSetup &&
        !this.loadingPractice &&
        !this.tra.trainer_error &&
        this.hero_spot &&
        this.history_spot_trainer
      ) {
        console.log('silentlyFetchSolution hero_spot')
        this.$store.dispatch('api_practice_silent', { namespace: this.namespace })
      }
    },
    handleQuizzTypeUpdate() {
      console.log('quizz-type update - silentlyFetchSolution')
      this.$store.dispatch('api_practice_silent', { namespace: this.namespace })
    },
    getOpponentFrequency() {
      if (!this.hasSilentFetch) return
      if (this.showdown_spot) return

      // const actionsHaveFrequencies = this.available_actions.some(i => 'frequency' in i)
      const actionsHaveFrequencies = this.available_actions.some(a => a.frequency)
      if (
        !actionsHaveFrequencies &&
        !this.loadingSession &&
        !this.loadingSetup &&
        !this.loadingPractice &&
        !this.tra.trainer_error &&
        this.bot_spot &&
        this.history_spot?.selected_action_code
      ) {
        console.log('silentlyFetchSolution bot_spot')
        this.$store.dispatch('api_practice_bot_silent', { namespace: this.namespace })
      }
    },
    handleHeroSpotChange(spot) {
      this.tra.trainer_result_visible =
        this.tra.trainer_hand_finished || !!spot?.selected_action_code
      // console.log('handleHeroSpotChange')
      this.getHeroCorrectness()
    },
    handleBotSpotChange(spot) {
      this.tra.trainer_result_visible = this.tra.trainer_hand_finished || !!spot
      // console.log('handleBotSpotChange')
      this.getOpponentFrequency()
    },
    handleSpotChange() {
      // console.log('handleSpotChange')
      if (this.hero_spot) {
        this.handleHeroSpotChange(this.history_spot_trainer)
      } else if (this.bot_spot) {
        this.handleBotSpotChange(this.history_spot_trainer)
      }
    },
    stopTimebank() {
      this.$store.dispatch(`${this.namespace}/trainer_clear_timebank`)
    },
  },
  computed: {
    available_actions() {
      const res = [...this.$store.getters[`${this.namespace}/available_actions`]]
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = res.slice(0, 9)
      // res = res.slice(0, 8)
      // res = res.slice(0, 7)
      // res = res.slice(0, 5)
      // res = res.slice(0, 4)
      // res = res.slice(0, 3)
      // res = res.slice(0, 2)
      // res = res.slice(0, 1)
      // res = res.slice(0, 24)
      // res = res.slice(0, 22)
      return res
    },
    // available_actions() { return this.$store.getters[`${this.namespace}/available_actions`] },
    manyActions() {
      const l = this.available_actions.length
      // const res = l > 6
      const res = this.mobile || this.multipleTables ? l > 6 : l > 9
      // return false
      // return true
      return res
    },
    tra() {
      switch (this.namespace) {
        case 'tra/alpha':
          return this.$store.state.tra.alpha.trainer
        case 'tra/beta':
          return this.$store.state.tra.beta.trainer
        case 'tra/gamma':
          return this.$store.state.tra.gamma.trainer
        case 'tra/delta':
          return this.$store.state.tra.delta.trainer
        case 'tra/replay':
          return this.$store.state.tra.replay.trainer
        case 'tmp/extra3':
          return this.$store.state.tmp.extra3.trainer
        default:
          return null
      }
    },
    quizzVisible() {
      return this.$store.getters[`${this.namespace}/trainer_quizz_visible`]
    },

    resultAsChart() {
      return (
        this.$store.getters.sw_trainer_result_chart === 'swv_trainer_result_chart' ||
        this.manyActions
      )
    },
    preselectedAction() {
      return this.available_actions.find(a => a.is_preselected)
    },
    querySetup() {
      return this.$store.getters[`${this.namespace}/query_fullhand_setup`]
    },
    gameformat() {
      return this.$store.getters[`${this.namespace}/gameformat`]
    },

    customTree() {
      const solElite = this.$store.getters[`tra/alpha/sol_elite`]
      return this.$store.getters[`${this.namespace}/trainer_custom_tree`] || solElite?.cTree
    },

    queryGameformat() {
      return this.$store.getters[`${this.namespace}/query_gameformat`]
    },
    queryHandTmp() {
      return this.$store.getters[`${this.namespace}/query_hand_tmp`]
    },
    queryHandOpTmp() {
      return this.$store.getters[`${this.namespace}/query_hand_op_tmp`]
    },
    queryStandoff() {
      return this.$store.getters[`${this.namespace}/query_trainer_standoff`]
    },

    useNextPlayer() {
      return this.$store.getters[`${this.namespace}/gamestate_next_player`]
    },
    useNextPot() {
      return this.$store.getters[`${this.namespace}/gamestate_next_pot`]
    },
    useNextBoard() {
      return this.$store.getters[`${this.namespace}/gamestate_next_board`]
    },
    betInPot() {
      return this.$store.getters[`${this.namespace}/gamestate_betinpot`]
    },

    quickResult() {
      return this.$store.getters[`${this.namespace}/trainer_quick_result`]
    },
    tableLocked() {
      return this.$store.getters[`${this.namespace}/trainer_table_locked`]
    },

    newHandTimeout() {
      return this.$store.getters[`${this.namespace}/trainer_new_hand_timeout`]
    },
    l_historyHand() {
      return this.historyHand || this.$store.getters[`${this.namespace}/trainer_history_hand`]
    },

    history_spot_trainer() {
      return this.$store.getters[`${this.namespace}/history_spot_trainer`]
    },
    sliderActions() {
      return this.$store.getters[`${this.namespace}/trainer_slider_actions`]
    },
    hs_slider_actions() {
      return this.history_spot_trainer?.slider_actions || []
    },
    // object with api_practice apiData
    history_spot() {
      const hSpot = this.$store.getters[`${this.namespace}/history_spot`]
      const streetBoardAny = this.$store.getters[`${this.namespace}/street_board_any`](
        hSpot?.street,
      )
      let nextStreetBoardAny = this.$store.getters[`${this.namespace}/street_board_any`](
        hSpot?.next_street,
      )
      // console.log(hSpot)
      const selected_action_outcome = hSpot?.selected_action_outcome
      if (selected_action_outcome !== 'board') {
        // handle gamestate_next on first hero action - play till the end then select next game custom_spot from dialog on preflop
        nextStreetBoardAny = streetBoardAny
      }

      const board = streetBoardAny.filter(c => !c.includes('E')).join('')
      const next_board = nextStreetBoardAny.filter(c => !c.includes('E')).join('')
      const res = hSpot
        ? {
            ...hSpot,
            board,
            next_board,
          }
        : null

      return res
    },
    currentPot() {
      return this.history_spot?.pot
    },
    bettingInfo() {
      const apiHero = (this.overviewSpot?.api_practice?.players_info || []).find(
        i => i.player?.is_hero,
      )
      return {
        pot: this.currentPot,
        showEvIn: this.$store.getters.show_ev_in,
        showEvIcmIn: this.$store.getters.show_ev_icm_in,
        evIcmConverters: [apiHero?.tournament_evs_converter],
      }
    },

    history_spot_id() {
      return this.$store.getters[`${this.namespace}/history_spot_id`]
    },
    showdown_spot() {
      return this.$store.getters[`${this.namespace}/showdown_spot`]
    },
    hero_spot() {
      return this.$store.getters[`${this.namespace}/hero_spot`]
    },
    bot_spot() {
      return this.$store.getters[`${this.namespace}/bot_spot`]
    },

    loadingSession() {
      return this.$store.getters.api_get('api_practice_session')?.loading
    },
    loadingSetup() {
      return this.$store.getters.api_get('api_practice_setup', this.namespace)?.loading
    },
    loadingShowdown() {
      return this.$store.getters.api_get('api_practice_showdown', this.namespace)?.loading
    },
    loadingPractice() {
      return this.$store.getters.api_get('api_practice', this.namespace)?.loading
    },
    loadingPracticeBot() {
      return this.$store.getters.api_get('api_practice_bot_action', this.namespace)?.loading
    },
    loadingActionTracking() {
      return this.$store.getters.api_get('api_practice_action_tracking', this.namespace)?.loading
    },
    loading() {
      const res =
        this.loadingSession ||
        this.loadingSetup ||
        this.playerAnimation.waiting ||
        this.loadingActionTracking ||
        this.loadingPractice ||
        this.loadingPracticeBot
      // console.log({
      //   loadingSession: this.loadingSession,
      //   loadingSetup: this.loadingSetup,
      //   playerAnimation: this.playerAnimation,
      //   loadingActionTracking: this.loadingActionTracking,
      //   loadingPractice: this.loadingPractice,
      //   loadingPracticeBot: this.loadingPracticeBot,
      // })
      // console.log('loading', res)
      return res
    },
    playerAnimation() {
      return this.$store.getters[`${this.namespace}/player_animation`]
    },
    instaNewHand() {
      return this.pref.fh_trainer_autoplay === '0_sec'
    },
    sessionMode() {
      return this.pref.fh_trainer_session
    },
    autoNewHand() {
      return this.$store.getters[`${this.namespace}/trainer_auto_new_hand`]
    },

    stopAfterAction() {
      return this.pref.fh_trainer_mode === 'stop_after_action'
    },
    stopEndOfStreet() {
      return this.pref.fh_trainer_mode === 'stop_end_of_street'
    },

    modeActions() {
      return this.pref.fh_trainer_game_mode === 'trainer_actions'
    },
    gmfNotICM() {
      return this.gameformat?.format !== 'icm'
    },
    hasDepthText() {
      return this.isPreflop && !this.mobile && !this.multipleTables && this.gmfNotICM
    },

    rng() {
      return this.history_spot_trainer?.rng
    },
    heroPosition() {
      return this.querySetup.fh_hero_tmp || this.querySetup.fh_hero
    },
    hasMobileStreetBtns() {
      return this.mobile && this.tra.trainer_hand_finished && !this.showdown_spot
    },

    skeletonTiles() {
      return this.$store.getters[`${this.namespace}/history_spots`].length || 8
    },
    isPreflop() {
      return this.history_spot_trainer?.street === 'preflop'
    },

    focusMode() {
      return this.$store.getters.focus_mode
    },

    numOfTables() {
      return this.$store.getters[`tra/alpha/fh_trainer_tables`]
    },
    multipleTables() {
      return this.hasMultipleTables && this.numOfTables > 1
    },
    sessionCount() {
      return this.$store.getters.session_count
    },
    hasSessionCount() {
      return this.multipleTables || !this.hasSession ? false : !!this.pref.fh_trainer_session
    },

    tableHasStreak() {
      return !!this.pref.fh_trainer_streak_visible && !this.multipleTables && this.hasStreak
    },
    streak() {
      return this.$store.getters.streak
    },
    pref() {
      const qqfh = this.querySetup
      const res = {
        fh_trainer_mode: qqfh.fh_trainer_mode,
        fh_trainer_game_mode: qqfh.fh_trainer_game_mode,

        fh_trainer_result: qqfh.fh_trainer_result,
        // fh_trainer_result_chart: qqfh.fh_trainer_result_chart,
        fh_trainer_quick_result: !!qqfh.fh_trainer_quick_result,
        fh_trainer_session: qqfh.fh_trainer_session,

        fh_trainer_autoplay: qqfh.fh_trainer_autoplay,
        fh_trainer_hero_frequency: qqfh.fh_trainer_hero_frequency,

        fh_rng: qqfh.fh_rng,
        fh_trainer_rng_visible: qqfh.fh_rng ? true : !!qqfh.fh_trainer_rng_visible, // rng is force visible whne using low/high rng
        fh_trainer_streak_visible: qqfh.fh_trainer_streak_visible,
      }
      // console.log(res, this.namespace)
      return res
    },
    chartProps() {
      const res = {
        actions: this.available_actions,
        hasFrequencyChart: !this.mobile && this.resultAsChart,
        hasHorizontalChart: this.mobile || !this.resultAsChart,
        horChartClass: this.mobile ? '' : 'horchart_legend-inline',
        horChartStyle: this.mobile ? '--chart-height: 0.875rem' : '',
        skeleton: this.loading,
        grouping: 'swv_grouping_none',
      }
      // console.log(res)
      return res
    },
    actionsProps() {
      const grouping = this.bot_spot ? 'swv_grouping_none' : this.grouping
      const manyBtnActions = grouping !== 'swv_grouping_none' ? false : this.manyActions
      const actions = this.available_actions

      const hasResult = this.tra.trainer_result_visible

      const botSpotWithFrequency = !!this.bot_spot && actions.some(a => a.frequency)
      const heroSpotSolved = !!this.hero_spot && actions.some(a => a.correctness !== 'na')
      const hasChart = hasResult && (botSpotWithFrequency || heroSpotSolved)

      const hasSlider = this.bot_spot ? false : !this.modeActions
      const resultAsChart = hasResult && this.modeActions && this.resultAsChart

      const hasComplexActions = resultAsChart
        ? true
        : (this.modeActions || this.bot_spot) && manyBtnActions
      const hasActions = resultAsChart
        ? false
        : (this.modeActions || this.bot_spot) && !manyBtnActions

      const common = {
        hasActions,
        hasComplexActions,
        hasSlider,
        hasFreq: true,
        hasEv: !!this.hero_spot,
        grouping,
      }
      let res = null

      if (this.tableLocked) {
        res = {}
      } else if (this.showdown_spot || this.loadingShowdown) {
        if (this.instaNewHand && this.loadingShowdown) {
          res = {
            loading: true,
            hasActions: this.modeActions,
            hasSlider: !this.modeActions,
          }
        } else if (
          this.instaNewHand &&
          !this.$store.getters[`${this.namespace}/trainer_instahand_gg_visible`]
        ) {
          // opponent cards flash
          res = {}
        } else if (this.sessionMode) {
          res = {
            hasFinishMessage: true,
          }
        } else {
          res = {
            hasFinishMessage: true,
          }
        }
      } else if (this.loading) {
        const noNothing =
          !this.loadingPractice && (this.playerAnimation.is_bot || this.loadingActionTracking)
        const loadingBtns = manyBtnActions
          ? 2
          : this.grouping === 'swv_grouping_none'
            ? 5
            : this.grouping === 'swv_grouping_4'
              ? 5
              : 2

        res = {
          loading: true,
          hasActions: noNothing ? false : this.bot_spot ? true : this.modeActions,
          hasSlider: noNothing ? false : this.bot_spot ? false : !this.modeActions,
          loadingBtns,
        }
      } else if (this.bot_spot) {
        res = {
          ...common,
          hasResult,
          hasChart,
          actions,
          selectKey: 'is_selected',
          hasCheatFrequency: true,
        }
      } else {
        res = {
          ...common,
          hasResult,
          hasChart,
          actions,
          manyActions: this.manyActions,
          sliderActions: this.hs_slider_actions,
          selectKey: 'is_preselected',
          hasBetHotkeys: !manyBtnActions,
          hasCheatFrequency: !!this.pref.fh_trainer_hero_frequency,
        }
      }
      // console.log(this.history_spot)
      // console.log(res)
      return res
    },
    confirmBtnsProps() {
      let res = {}

      const error = this.tra.trainer_error
      const finished = this.tra.trainer_hand_finished
      const resVisible = this.tra.trainer_result_visible
      const btnsOnSide =
        this.hasMultipleTables && (this.numOfTables > 2 || (this.numOfTables === 2 && this.max1280))

      const retryBtns = {
        hasNewHand: !this.newHandTimeout,
        hasStopNewHand: !!this.newHandTimeout,
        hasMenu: this.mobile && this.confirmBtnsHasMenu && !error,
      }

      const hasResultSwitcher = !this.mobile && resVisible && !this.manyActions && !error
      const lastSpot = this.$store.getters[`${this.namespace}/last_spot`]
      const arrowBtns = {
        hasForward: !this.mobile && finished,
        hasBack: !this.mobile && finished,
        forwardDisabled: this.history_spot_trainer?.id === lastSpot?.id,
        backDisabled: this.history_spot_trainer?.id === 0,
      }
      if (!this.hasConfirmBtns) {
        return arrowBtns
      }

      if (this.tableLocked) {
        //
      } else if (this.loading) {
        //
      } else if (error) {
        const errsStatus = error?.result?.error?.request?.status
        res =
          errsStatus === 403
            ? {
                hasStopHands: true,
                hasNewHand: false,
              }
            : errsStatus === 429
              ? {
                  hasStopHands: true,
                  hasNewHand: false,
                }
              : {
                  hasStopHands: true,
                  hasRepeatHand: true,
                  hasNewHand: true,
                }
      } else if (this.showdown_spot || this.loadingShowdown) {
        const lastPlayerSpot = findLast(
          this.$store.getters[`${this.namespace}/history_spots`],
          i => i.type === 'player',
        )
        const lastActionTaken = lastPlayerSpot?.available_actions?.find(i => i.is_selected)
        const hasSolutionEndMessage = !this.stopEndOfStreet && lastActionTaken?.is_fe_solution_end

        // console.log(lastActionTaken)
        // debugger

        if ((this.instaNewHand && !this.showdown_spot) || this.loadingShowdown) {
          res = {}
        } else if (
          this.instaNewHand &&
          !this.$store.getters[`${this.namespace}/trainer_instahand_gg_visible`]
        ) {
          // opponent cards flash
          res = {
            hasSolutionEndMessage,
          }
        } else {
          res = {
            hasRepeatHand: true,
            hasPreferencesMenu: !this.mobile && !this.replayOnly,
            btnsOnSide,
            hasSolutionEndMessage,
            ...retryBtns,
            ...arrowBtns,
          }
        }
      } else if (finished) {
        if (this.bot_spot) {
          res = {
            hasPlayAsHero: resVisible,
            btnsOnSide,
            hasResultSwitcher,
            ...arrowBtns,
            ...retryBtns,
          }
        } else {
          res = {
            hasReturnToGame: true,
            btnsOnSide,
            hasResultSwitcher,
            ...retryBtns,
            ...arrowBtns,
          }
        }
      } else if (this.bot_spot) {
        res = {
          hasPlayAsHero: resVisible,
          hasChangeBotAction: resVisible,
          btnsOnSide,
          hasResultSwitcher,
          ...arrowBtns,
        }
      } else if (this.stopAfterAction && this.tra.trainer_result_visible) {
        res = {
          hasNewHand: true,
          btnsOnSide,
        }
      } else {
        const actionOutcome = this.preselectedAction?.outcome
        const showdown =
          (this.stopEndOfStreet && actionOutcome === 'board') ||
          this.preselectedAction?.is_fe_solution_end ||
          actionOutcome === 'showdown'

        res = {
          hasConfirmSlider: !finished && !resVisible && !this.modeActions,
          hasChangeMove: !finished && resVisible,
          hasContinue: !finished && resVisible,
          showdown,
          btnsOnSide,
          hasResultSwitcher,
          ...arrowBtns,
        }
      }

      if (this.repeatHandBtnAsPrimary) {
        if (res.hasNewHand && res.hasRepeatHand) {
          res = {
            ...res,
            hasNewHand: false,
            hasRepeatHand: false,
            hasNewHandSecondary: true,
            hasRepeatHandPrimary: true,
          }
        } else if (res.hasNewHand) {
          res = {
            ...res,
            hasNewHand: false,
            hasRepeatHand: false,
            hasRepeatHandPrimary: true,
          }
        }
      }

      if (this.history_spot?.forced_fold) {
        res.hasNewHand = false
        res.hasRepeatHand = false
        res.hasNewHandSecondary = false
        res.hasRepeatHandPrimary = false
        res.hasContinue = false
        res.hasChangeMove = false
        res.hasConfirmSlider = false
        res.hasChangeBotAction = false
        res.hasPlayAsHero = false
        res.hasReturnToGame = false
      }

      // console.log('dbg_computed -- confirmBtnsProps')
      // console.log(res)
      return res
    },
    confirmBtnsEvents() {
      return {
        changeMove: this.changeMove,
        continue: () => this.confirmActionSelection(this.preselectedAction),
        confirmSlider: () => this.handleConfirmSlider(),
        playAsHero: this.switchToCustomSpotHand,
        returnToGame: this.returnToGame,
        changeBotAction: this.changeBotAction,
        go: this.go,
        newHand: this.newHand,
        stopNewHand: this.stopNewHand,
        repeatHand: this.repeatHand,
        stopHands: this.stopHands,
      }
    },
    swipePanelProps() {
      let open = false
      let ignoreSwipeVertical = true
      if (this.mobile) {
        if (this.loadingShowdown || this.showdown_spot) {
          if (this.loadingShowdown) {
            open = false
            ignoreSwipeVertical = true
          } else if (
            this.instaNewHand &&
            !this.$store.getters[`${this.namespace}/trainer_instahand_gg_visible`]
          ) {
            // opponent cards flash
            open = false
            ignoreSwipeVertical = true
          } else {
            open = true
            ignoreSwipeVertical = false
          }
        } else if (this.loading) {
          open = false
          ignoreSwipeVertical = true
        } else {
          open = this.tra.trainer_result_visible
          ignoreSwipeVertical = !this.tra.trainer_result_visible
        }
      }
      const res = {
        open,
        ignoreSwipeVertical,
        ignoreSwipeHorizontal: !this.mobile,
        style: '--exp-height: var(--aa-height)',
      }
      // console.log(res)
      return res
    },
    apiPractice() {
      return this.history_spot_trainer?.api_practice
    },
    // quizzChallenge() { return this.history_spot_trainer?.api_practice?.challenge },
    overviewSpot() {
      return this.$store.getters[`${this.namespace}/trainer_overview_spot`]
    },
    infoVisible() {
      return this.$store.getters[`${this.namespace}/trainer_info_visible`]
    },
  },
  watch: {
    apiPractice: {
      immediate: true,
      handler: 'setOverviewSpot',
    },
    history_spot_id: {
      immediate: true,
      handler: 'handleSpotChange',
    },
    infoVisible() {
      this.trbc_dataToReceiver({ trigger: 'infoVisible', namespace: this.namespace })
    },
    overviewSpot() {
      this.trbc_dataToReceiver({ trigger: 'overviewSpot', namespace: this.namespace })
    },
    loading() {
      this.trbc_dataToReceiver({ trigger: 'loading', namespace: this.namespace })
    },
  },
}
</script>
<style lang="scss">
@media (max-width: 1023px) {
  .tralay {
    &_left {
      order: 4 !important;
    }
    &_right {
      order: 5 !important;
    }
  }
}
.tralay {
  display: flex;
  width: 100%;
  flex: 1;
  --tralay-height: 100%;
  // --clr-tra-hs-back: var(--clr-black-0);
  height: var(--tralay-height);

  overflow: hidden;
  position: relative;
  overflow: clip;

  --c-width: 100%;
  --c-margin: 0 auto auto auto;
  // --c-width: 72em;
  // --c-margin: auto;

  --ct-size: clamp(0.7em, 2vh, 1em);
  --ct-width: 72em;
  // --ct-width: 82em;

  --hs-margin: 0;
  --hs-padding: 0 0.75rem 0 0.75rem;
  // --hs-padding: 0.125rem 0.75rem 0 0.75rem;
  --hs-width: 100%;

  --gap: 2em;
  --pt-padding: var(--gap) 1em 0 1em;
  // --pt-padding: 1.75em 1em 0 1em;

  --pt-height: 24em;

  --tbl-ver-max-width: 32em;
  --tbl-hor-min-height: 24em;
  --tbl-hor-max-width: 100%;
  --tbl-standoff-top: -0.75rem;

  --aa-height: 18em;
  --aa-width: clamp(48em, 54.75em, 100%);
  --aa-content-height: var(--vh-6);

  --aa-content-padding: var(--gap) 0.25em 3.25rem 0.25em;
  --tralay-action-content-opacity: 0;
  // --aa-content-padding: 1em 0 0 0;

  // --aa-content-height: var(--vh-6);
  // --aa-content-padding: var(--gap) 0.25em 3.25rem 0.25em;

  // --focus-mode-center-margin: auto;

  --clr-trainer-table-outline: var(--clr-trainer_table_outline);
  --clr-trainer-table-back: var(--clr-trainer_table_back);
  &_locked {
    pointer-events: none;
    .traintabl_player,
    .traintabl_hints,
    .traintabl_controls,
    .traintabl_standoff,
    .traintabl_pot,
    .traintabl_rng,
    .tralay_hs {
      opacity: 0 !important;
    }
  }
  &_singletable {
    padding: 0.5rem 0 0 0;
  }
  &_multitable {
    --c-width: 82em;
    --pt-padding: 0.5em 1em 0 1em;
    --ct-size: inherit;

    --hs-padding: 0em 5em 0 5em;
    --tbl-standoff-top: -0.625em;

    --aa-width: clamp(38em, 52.75em, calc(100% - 6rem));
    --aa-content-padding: 0.75em 0.25em 3.25rem 0.25em;

    --aa-height: 14.5em;
    &.tralay_tables_2 {
      --aa-height: 18em;
    }

    // .tralay_center {
    //   margin: auto auto auto auto;
    // }

    --tralay-content-opacity: 0;
    // --tralay-content-opacity: 1;
    .traintabl_hints,
    .traintabl_controls,
    .tralay_hs,
    .tralay_result-view-switcher,
    .tralay_left,
    .tralay_right {
      opacity: var(--tralay-content-opacity);
      transition: opacity 0.22s;
    }
    &:hover {
      --tralay-content-opacity: 1;
    }
    &.tralay_active {
      --tralay-content-opacity: 1;
      --clr-trainer-table-back: var(--clr-trainer_active_table_back);
      --clr-trainer-table-outline: var(--clr-trainer_active_table_outline);
    }
  }
  &_center {
    order: 3;
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 1;
    margin: var(--c-margin);
    max-width: var(--c-width);
    // padding: 0.5rem 0 0 0;
    // background: rgba(255, 0, 0, 0.338);
    &_content {
      font-size: var(--ct-size);
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 100%;
      align-items: center;
      position: relative;
      max-width: var(--ct-width);
      .tralay_finish-message {
        margin: 0 auto;
      }
    }
  }
  &_mobile {
    padding: 0;
    .tralay_center {
      margin: 0;
      --ct-size: 1rem;
      --pt-padding: 0.5em 0 0 0;
      --hs-padding: 0;
      --aa-width: 100%;
      --aa-height: 10rem;
      --aa-content-padding: 0.75em 0.25em 0 0.25em;
      --aa-content-height: var(--aa-height);
      .tralay_slider {
        padding: 0.5rem 0.5rem 0 0.5rem;
      }
      .tralay_confirm-btns {
        background: var(--clr-black-1);
        padding: 0.5rem;
        position: fixed;
        // position: absolute;
        // bottom: 0;
        bottom: calc(var(--glo-footer-height) + var(--safe-area-inset-bottom));
        margin: 0;
        left: 0;
        z-index: 2;
        box-shadow: 0 -1px 2px var(--clr-black-0);
      }
    }
  }

  // --c-margin: var(--focus-mode-center-margin);
  // --hs-width: var(--ct-width);
  // --hs-width: 82em;
  // --hs-width: 80em;
  // --hs-width: 78em;
  // --hs-width: 76em;
  // --hs-width: 74em;
  // --hs-padding: 0 5em 0 5em;

  &_focus-mode {
    padding: 0;
    .tralay_center {
      --c-margin: var(--focus-mode-center-margin);
      --hs-width: var(--ct-width);
      // --hs-width: 82em;
      // --hs-width: 80em;
      // --hs-width: 78em;
      // --hs-width: 76em;
      // --hs-width: 74em;
      --hs-padding: 0 5em 0 5em;
    }
  }

  &_hs {
    width: 100%;
    max-width: var(--hs-width);
    margin: var(--hs-margin);
    // padding: var(--hs-padding);
  }
  &_table {
    width: 100%;
    padding: var(--pt-padding);
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    &_actions {
      width: var(--aa-width);
      margin: 0 auto;
      z-index: 8;
      &_content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: var(--aa-content-height);
        padding: var(--aa-content-padding);
        max-width: 100vw;

        margin: 0 auto; // for: firefox dont know how to keep things centered on resize - small screen only
        &_expanded {
          --aa-content-padding: 0.5em 0.25em 4rem 0.25em;
          --aa-content-height: var(--vh-6);
          background: var(--clr-black-0);
          overflow-x: hidden;
          overflow-y: auto;
          align-self: flex-end;
          .tralay {
            &_actions {
              margin-top: auto;
            }
            &_complex-actions {
              margin-top: auto;
            }
            &_slider {
              padding: 0 0.5rem;
            }
            &_freq-charts {
              padding: 0.5rem 0.5rem 1rem;
            }
          }
        }
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .tralay_singletable {
    overflow-y: auto; // small ipads and such
  }
}

.tralay {
  &_result-switcher {
    margin: 0.5rem auto 0 auto;
  }
  &_no-mobile-confirm-btns {
    .tralay_table_actions_content_expanded {
      --aa-content-padding: 0.5em 0.25em 0 0.25em;
      // --aa-content-padding: 0.5em 0.25em 4.25rem 0.25em;
    }
  }
  &_message-overlay {
    align-self: center;
    margin: auto;
  }
  &_session-message {
    position: absolute !important;
    z-index: 9;
  }
  &_top-street-btns {
    margin: 0.5em 0 0 0;
  }
  &_mobile-street-btns {
    margin-bottom: 0.25em;
  }
  &_configure {
    margin: 0;
    z-index: 5;
    position: relative;
  }
  &_freq-charts {
    margin: 1em 0 0 0;
  }
  &_confirm-btns {
    margin: 1em auto auto auto;
    // max-width: calc(1px, var(--aa-width), 100vw) !important;
  }
  &_finish-warning-message {
    background-color: rgb(43 35 20);
    position: absolute;
    color: var(--clr-yellow);
    padding: 0.125rem 0.5rem;
    white-space: nowrap;
    text-align: center;
    font-size: 0.8rem;
    top: 0;
    right: 0;
    border-radius: 0px 0px 0px 4px;
    z-index: 3;
    &_standalone {
      font-size: 1rem;
      border-radius: 4px;
      top: 1rem;
      right: unset;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  &_finish-message {
    margin: 0.5em auto 0 auto;
  }
  &_progress-line {
    bottom: 0;
    left: 0;
    position: absolute !important;
    width: 100%;
  }
  &_mhandle {
    // position: absolute;
    position: sticky;
    // top: -0.25em;
    // top: -0.75em;
    top: -0.5em;
    // top: 0em;
    z-index: 4;
    // z-index: 1;
    left: 50%;
    transform: translate(-50%, 0);
    // z-index: 1;
    background: var(--clr-black-2);
    width: 8em;
    height: 1em;
    border-radius: 99px;
    display: flex;
    align-items: center;
    justify-content: center;
    // position: relative;
    flex-shrink: 0;
    &:after {
      content: '';
      height: 1.5em;
      width: 100%;
      position: absolute;
      // background: var(--clr-black-1);
      width: 100vw;
      top: 0;
      // left: 0;
      // z-index: -1;
    }
    &_icon {
      position: absolute;
      color: var(--clr-grey-2);
      font-size: 1.5em;
      line-height: 1;
      transition: 0.22s;
    }
  }
}
</style>
